export const DYNAMIC_ZONE_COMPONENTS = {
  CONTENT_WITH_HEADING: "content-with-heading.content-with-heading",
  QUOTE: "quote.quote",
} as const;

// This constant is used to limit the number of articles that are
// displayed in the "Other Blog Posts" and "Other customer success stories"
// sections.
export const OTHER_ARTICLES_LIMIT = 3;
